import { useToast } from '@chakra-ui/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import config from 'config';
import { useAxios } from 'context/AxiosContextProvider';
import { manageErrorResponse } from 'helpers/manageErrorResponse';
import useWorkshopVerificationRequestQuery from 'hooks/useWorkshopVerificationRequestQuery';

async function updateDocs(
  axios: AxiosInstance,
  workshopVerificationId: number | undefined,
  params: {
    status: number;
    status_reason?: string;
  },
): Promise<object> {
  const { data } = await axios.put(`${config.apiBaseUrl}/op/v2/workshop-verification-request/${workshopVerificationId}/update-state`, {
    ...params,
  });
  return data;
}

export default function useWorkshopVerificationStateMutation(workshopVerificationId: number | undefined, mutationKey: string) {
  const queryClient = useQueryClient();
  const axios = useAxios();
  const toast = useToast();

  return useMutation({
    mutationFn: (params: { status: number; status_reason?: string }) => updateDocs(axios, workshopVerificationId, params),
    mutationKey: ['UpdateWorkshopVerificationStateMutation', mutationKey],
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: useWorkshopVerificationRequestQuery.getKey(workshopVerificationId),
      });
    },
    onError: (error: any) => {
      manageErrorResponse(toast, error.response.data);
    },
  });
}
